// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2B7ZT","alertIcon":"ConfirmModal_alertIcon__3uJkC"};